// extracted by mini-css-extract-plugin
export default {"iconButton":"iconButton-TDKiaisO","icon":"icon-Q_QDqrJ0","inverted":"inverted-Q5D1KIkb"};